import { IAppState } from '../../common/state';

export function selectNewbuildingBlackFridayActive(state: IAppState) {
  return state.featureToggle.newbuildingBlackFridaySettings.isActive;
}
